import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyState = ({
  title,
  hideBorder,
  description,
}: {
  title?: string
  description?: string
  hideBorder?: boolean
}) => (
  <Box
    border={
      !hideBorder && {
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }
    }
    padding="s32"
    textAlign="center"
  >
    <Text.Normal weight="medium">
      {title ||
        i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_approval_history.title'
        )}
    </Text.Normal>
    <Text.Normal size="200">
      {description ||
        i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_approval_history.new_description'
        )}
    </Text.Normal>
  </Box>
)

export default EmptyState
